import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Redirects /store or /tv to the unified landing hash when the standalone
// landing is toggled OFF in Global Admin -> Site Settings.
export default function LandingToggleGuard({ kind, hash, children }) {
  const [state, setState] = useState("loading"); // loading | show | redirect
  useEffect(() => {
    api.get("/site-settings").then(r => {
      const on = kind === "store" ? r.data.enable_store_landing : r.data.enable_tv_landing;
      if (on === false) { window.location.replace("/" + hash); setState("redirect"); }
      else setState("show");
    }).catch(() => setState("show"));
  }, [kind, hash]);
  if (state === "loading" || state === "redirect") return null;
  return children;
}
